import React from "react";

const WaterMark = ({text, style = {}}) => {
  return (
    <div
      style={{
        position: "absolute",
        zIndex: 10,
        top: "8rem",
        left: "3rem",
        right: 0,
        width: "90%",
        pointerEvents: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "3.3rem",
        color: "rgba(0,0,0,0.6)",
        transform: "rotate(-40deg)",
        letterSpacing: "0.4em",
        ...style,
      }}
    >
      {text}
    </div>
  );
};

export default WaterMark;
